export default __webpack_public_path__ + "static/media/mail_sent.a11bf4b1.svg";